import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 350px;
  align-items: center;
  justify-content: center;

  input {
    width: 250px;
    height: 35px;
    padding: 14px 16px 0 10px;
    outline: 0;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: #fff;
    font-size: 16px;
    box-shadow: 0px 3px 6px #00000029;
  }

  label {
    font-size: 16px;
    padding: 0 12 px;
    color: #999;
    pointer-events: none;
    position: absolute;
    left: 60px;
    top: 5px;
    transform: translate(0, 13px) scale(1);
    transform-origin: top left;
    transition: all 0.2s ease-out;
  }
  :focus-within label {
    transform: translate(0, 2px) scale(0.6);
  }

  .active {
    transform: translate(0, 2px) scale(0.6);
  }
`;

export default Container;
